import { TOKEN_DECIMALS } from './solana';

export const DEFAULT_MIN_SIZE = 1 * TOKEN_DECIMALS;
